import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
export default function LoginPage() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    async function onSubmit(e) {
        e.preventDefault();
        setError(null);
        setSubmitting(true);
        try {
            await login(email, password);
            navigate("/today");
        }
        catch (err) {
            setError(err instanceof Error ? err.message : "Login failed");
        }
        finally {
            setSubmitting(false);
        }
    }
    return (_jsxs("div", { className: "auth-card", children: [_jsx("h1", { children: "Sign in to ClockWork Rhythm" }), _jsxs("form", { onSubmit: onSubmit, children: [_jsxs("label", { children: ["Email", _jsx("input", { type: "email", value: email, onChange: (e) => setEmail(e.target.value), required: true, autoFocus: true })] }), _jsxs("label", { children: ["Password", _jsx("input", { type: "password", value: password, onChange: (e) => setPassword(e.target.value), required: true })] }), error && _jsx("div", { className: "error", children: error }), _jsx("button", { type: "submit", disabled: submitting, className: "btn-primary", children: submitting ? "Signing in…" : "Sign in" })] }), _jsx("p", { className: "auth-footer", children: "Accounts are created by an administrator. Contact your admin if you need access." })] }));
}
